import { arrayMoveImmutable } from "array-move";
import {
  LOAD_SIDEBAR_ITEMS,
  CLEAR_SIDEBAR_ITEMS,
  ADD_SIDEBAR_ITEM,
  TOGGLE_SIDEBAR_ITEM,
  REORDER_SIDEBAR_ITEM,
  UPDATE_SIDEBAR_ITEM,
} from "../actions/sidebarItems.js";

function sidebarItems(state = [], action) {
  switch (action.type) {
    case LOAD_SIDEBAR_ITEMS:
      return action.data;
    case CLEAR_SIDEBAR_ITEMS:
      return [];
    case ADD_SIDEBAR_ITEM:
      return [...state, action.data];
    case REORDER_SIDEBAR_ITEM: {
      // Drag indices count groups only, excluding pinned controls such as Grid Floor.
      const sortableItems = state.filter((item) => !item || item.sortable !== false);
      const { oldIndex, newIndex } = action.data || {};
      if (
        !Number.isInteger(oldIndex) || !Number.isInteger(newIndex) ||
        oldIndex < 0 || newIndex < 0 ||
        oldIndex >= sortableItems.length || newIndex >= sortableItems.length ||
        oldIndex === newIndex
      ) {
        return state;
      }
      const reorderedItems = arrayMoveImmutable(sortableItems, oldIndex, newIndex);
      let sortableIndex = 0;
      return state.map((item) =>
        item && item.sortable === false ? item : reorderedItems[sortableIndex++]
      );
    }
    case TOGGLE_SIDEBAR_ITEM:
      let updatedSidebar = Object.assign([], state);
      let exists = false;
      for (let i = 0; i < updatedSidebar.length; i++) {
        if (updatedSidebar[i].id === action.data.id) {
          exists = true;
          updatedSidebar.splice(i, 1);
        }
      }
      if (!exists) {
        updatedSidebar.unshift(action.data);
      }
      return updatedSidebar;
    case UPDATE_SIDEBAR_ITEM:
      return state.map((item) => (item.id === action.data.id ? action.data : item));
    default:
      return state;
  }
}

export default sidebarItems;
